const vehicles = {
    en: {
        "vehicles.title": "Cars",

        // table headers / card fields
        "vehicles.image": "Image",
        "vehicles.dealer": "Dealer",
        "vehicles.purchaseDate": "Purchase Date",
        "vehicles.vehicleName": "Vehicle Name",
        "vehicles.receiver": "Receiver",
        "vehicles.personalNumber": "Personal Number",
        "vehicles.phone": "Phone",
        "vehicles.container": "Container",
        "vehicles.booking": "Booking",
        "vehicles.line": "Line",
        "vehicles.auction": "Auction",
        "vehicles.state": "State",
        "vehicles.paid": "Paid",
        "vehicles.transportation": "Transportation",
        "vehicles.carAmount": "Car Amount",
        "vehicles.debt": "Debt",
        "vehicles.status": "Status",
        "vehicles.green": "Green",

        // action menu
        "vehicles.addReceiver": "Add Receiver",
        "vehicles.markAsGreen": "Mark As Green",
        "vehicles.uploadImages": "Upload Images",
        "vehicles.containerLoaded": "Container loaded",
        "vehicles.addNote": "Add Note",
        "vehicles.carInvoice": "Car Invoice",
        "vehicles.transportationInvoice": "Transportation Invoice",

        // filters
        "vehicles.sortContainerLoaded": "Container Loaded Date",
        "vehicles.sortContainerReceive": "Container Receive Date",
        "vehicles.sortEstOpening": "Estimated Opening Date",
        "vehicles.sortOpenDate": "Open Date",
        "vehicles.sortDesc": "Desc",
        "vehicles.oldToNew": "Old To New",
        "vehicles.newToOld": "New To Old",
        "vehicles.port": "Port",
        "vehicles.portNumber1": "Port number 1",
        "vehicles.portNumber2": "Port number 2",
        "vehicles.portNumber3": "Port number 3",
        "vehicles.selectLine": "Select Line",

        // confirmation
        "vehicles.confirmPrompt": "Do you want",
        "vehicles.confirmRemoveCar": "to remove this car",
        "vehicles.confirmMarkGreen": "to mark this car as green",
        "vehicles.confirmContainerLoaded": "Mark container as loaded",
        "vehicles.estimatedReceiveDate": "Estimated Receive Date",

        // create / edit vehicle
        "vehicles.modifyCarData": "Modify Car Data",
        "vehicles.addNewCar": "Add New Car",
        "vehicles.user": "User",
        "vehicles.enterUser": "Enter user",
        "vehicles.userNotFound": "User Not Found",
        "vehicles.enterVin": "Enter VIN Code",
        "vehicles.mark": "Mark",
        "vehicles.enterMark": "Enter mark",
        "vehicles.model": "Model",
        "vehicles.enterModel": "Enter model",
        "vehicles.year": "Year",
        "vehicles.enterYear": "Enter year",
        "vehicles.lotNumber": "Lot number",
        "vehicles.enterLotNumber": "Enter lot number",
        "vehicles.selectAuction": "Select Auction",
        "vehicles.usState": "US state",
        "vehicles.enterUsState": "Enter us state",
        "vehicles.cityNotFound": "City Not Found",
        "vehicles.usPort": "US port",
        "vehicles.selectDestinationPort": "Select Destination Port",
        "vehicles.destinationPort": "Destination port",
        "vehicles.documentType": "Document type",
        "vehicles.enterDocType": "Enter doc. type",
        "vehicles.containerCost": "Container cost",
        "vehicles.enterContainerCost": "Enter container cost",
        "vehicles.landingCost": "Landing cost",
        "vehicles.enterLandingCost": "Enter landing cost",
        "vehicles.vehiclePrice": "Vehicle price",
        "vehicles.enterVehiclePrice": "Enter vehicle price",
        "vehicles.totalPrice": "Total price",
        "vehicles.enterTotalPrice": "Enter total price",
        "vehicles.vehicleAdditionalAmount": "Vehicle additional amount",
        "vehicles.transportationAdditionalAmount": "Transportation additional amount",
        "vehicles.buyerNumber": "Buyer number",
        "vehicles.enterBuyerNumber": "Enter buyer number",
        "vehicles.vehicleType": "Vehicle type",
        "vehicles.selectVehicleType": "Select Vehicle Type",
        "vehicles.typeSedan": "Sedan/Hatchback",
        "vehicles.typeJeep": "Jeep/Crossover",
        "vehicles.typeJeepOversize": "Jeep Oversize",
        "vehicles.typeMinivan": "Minivan",
        "vehicles.typeMicrobus": "Micro Auto Bus",
        "vehicles.typeJetski": "Jet Ski-Snowmobile",
        "vehicles.typeMotorcycle": "Motorcycle",
        "vehicles.insuranceType": "Insuranse type",
        "vehicles.hasKey": "Has Key",
        "vehicles.isHybrid": "Is Hybrid",
        "vehicles.isSublot": "Is Sublot",
        "vehicles.isFunded": "Is Funded",
        "vehicles.isInsured": "Is Insured",
        "vehicles.isClosedCode": "Closed code (+$100)",
        "vehicles.pending": "Pending",
        "vehicles.attachImage": "Attach Image",
        "vehicles.saveAndAttach": "Save & Attach Images",
        "vehicles.upload": "Upload",

        // upload images
        "vehicles.selectImageType": "Select Image Type",
        "vehicles.poti": "Poti",
        "vehicles.selectImageTypeWarning": "Please Select Images type",

        // add receiver
        "vehicles.receiverFullName": "Receiver Full Name",
        "vehicles.receiverIdentityNumber": "Receiver Identity Number",
        "vehicles.receiverPhone": "Receiver Phone",

        // receiver 2-day rule
        "vehicles.receiverRequired": "Receiver needed",
        "vehicles.receiverTimeLeft": "Time left to assign receiver",
        "vehicles.receiverExpired": "Deadline passed",
        "vehicles.receiverReminderText": "Please assign the receiver within the deadline — after that only an administrator can change it.",
        "vehicles.receiverLockedTitle": "Receiver locked",
        "vehicles.receiverLockedText": "The deadline to change the receiver has passed. Please contact the administrator.",
        "vehicles.receiverSet": "Receiver assigned",
        "vehicles.unitDay": "d",
        "vehicles.unitHour": "h",
        "vehicles.unitMinute": "m",

        // title tracking
        "vehicles.titleReceivedDate": "Title received date",
        "vehicles.titleMissing": "No title",
        "vehicles.titleWarning": "Loaded without title!",
        "vehicles.titleReceived": "Title received",
    },
    ru: {
        "vehicles.title": "Автомобили",

        "vehicles.image": "Изображение",
        "vehicles.dealer": "Дилер",
        "vehicles.purchaseDate": "Дата покупки",
        "vehicles.vehicleName": "Название автомобиля",
        "vehicles.receiver": "Получатель",
        "vehicles.personalNumber": "Личный номер",
        "vehicles.phone": "Телефон",
        "vehicles.container": "Контейнер",
        "vehicles.booking": "Бронирование",
        "vehicles.line": "Линия",
        "vehicles.auction": "Аукцион",
        "vehicles.state": "Штат",
        "vehicles.paid": "Оплачено",
        "vehicles.transportation": "Транспортировка",
        "vehicles.carAmount": "Стоимость авто",
        "vehicles.debt": "Долг",
        "vehicles.status": "Статус",
        "vehicles.green": "Зелёный",

        "vehicles.addReceiver": "Добавить получателя",
        "vehicles.markAsGreen": "Отметить как зелёный",
        "vehicles.uploadImages": "Загрузить изображения",
        "vehicles.containerLoaded": "Контейнер загружен",
        "vehicles.addNote": "Добавить заметку",
        "vehicles.carInvoice": "Инвойс автомобиля",
        "vehicles.transportationInvoice": "Инвойс транспортировки",

        "vehicles.sortContainerLoaded": "Дата загрузки контейнера",
        "vehicles.sortContainerReceive": "Дата получения контейнера",
        "vehicles.sortEstOpening": "Предполагаемая дата открытия",
        "vehicles.sortOpenDate": "Дата открытия",
        "vehicles.sortDesc": "По убыванию",
        "vehicles.oldToNew": "От старых к новым",
        "vehicles.newToOld": "От новых к старым",
        "vehicles.port": "Порт",
        "vehicles.portNumber1": "Порт номер 1",
        "vehicles.portNumber2": "Порт номер 2",
        "vehicles.portNumber3": "Порт номер 3",
        "vehicles.selectLine": "Выберите линию",

        "vehicles.confirmPrompt": "Вы хотите",
        "vehicles.confirmRemoveCar": "удалить этот автомобиль",
        "vehicles.confirmMarkGreen": "отметить этот автомобиль как зелёный",
        "vehicles.confirmContainerLoaded": "Отметить контейнер как загруженный",
        "vehicles.estimatedReceiveDate": "Предполагаемая дата получения",

        "vehicles.modifyCarData": "Изменить данные автомобиля",
        "vehicles.addNewCar": "Добавить новый автомобиль",
        "vehicles.user": "Пользователь",
        "vehicles.enterUser": "Введите пользователя",
        "vehicles.userNotFound": "Пользователь не найден",
        "vehicles.enterVin": "Введите VIN код",
        "vehicles.mark": "Марка",
        "vehicles.enterMark": "Введите марку",
        "vehicles.model": "Модель",
        "vehicles.enterModel": "Введите модель",
        "vehicles.year": "Год",
        "vehicles.enterYear": "Введите год",
        "vehicles.lotNumber": "Номер лота",
        "vehicles.enterLotNumber": "Введите номер лота",
        "vehicles.selectAuction": "Выберите аукцион",
        "vehicles.usState": "Штат США",
        "vehicles.enterUsState": "Введите штат США",
        "vehicles.cityNotFound": "Город не найден",
        "vehicles.usPort": "Порт США",
        "vehicles.selectDestinationPort": "Выберите порт назначения",
        "vehicles.destinationPort": "Порт назначения",
        "vehicles.documentType": "Тип документа",
        "vehicles.enterDocType": "Введите тип документа",
        "vehicles.containerCost": "Стоимость контейнера",
        "vehicles.enterContainerCost": "Введите стоимость контейнера",
        "vehicles.landingCost": "Стоимость выгрузки",
        "vehicles.enterLandingCost": "Введите стоимость выгрузки",
        "vehicles.vehiclePrice": "Цена автомобиля",
        "vehicles.enterVehiclePrice": "Введите цену автомобиля",
        "vehicles.totalPrice": "Общая цена",
        "vehicles.enterTotalPrice": "Введите общую цену",
        "vehicles.vehicleAdditionalAmount": "Дополнительная сумма за авто",
        "vehicles.transportationAdditionalAmount": "Дополнительная сумма за транспортировку",
        "vehicles.buyerNumber": "Номер покупателя",
        "vehicles.enterBuyerNumber": "Введите номер покупателя",
        "vehicles.vehicleType": "Тип автомобиля",
        "vehicles.selectVehicleType": "Выберите тип автомобиля",
        "vehicles.typeSedan": "Седан/Хэтчбек",
        "vehicles.typeJeep": "Джип/Кроссовер",
        "vehicles.typeJeepOversize": "Джип увеличенный",
        "vehicles.typeMinivan": "Минивэн",
        "vehicles.typeMicrobus": "Микроавтобус",
        "vehicles.typeJetski": "Гидроцикл-Снегоход",
        "vehicles.typeMotorcycle": "Мотоцикл",
        "vehicles.insuranceType": "Тип страховки",
        "vehicles.hasKey": "Есть ключ",
        "vehicles.isHybrid": "Гибрид",
        "vehicles.isSublot": "Сублот",
        "vehicles.isFunded": "Профинансирован",
        "vehicles.isInsured": "Застрахован",
        "vehicles.isClosedCode": "Закрытый код (+$100)",
        "vehicles.pending": "В ожидании",
        "vehicles.attachImage": "Прикрепить изображение",
        "vehicles.saveAndAttach": "Сохранить и прикрепить изображения",
        "vehicles.upload": "Загрузить",

        "vehicles.selectImageType": "Выберите тип изображения",
        "vehicles.poti": "Поти",
        "vehicles.selectImageTypeWarning": "Пожалуйста, выберите тип изображений",

        "vehicles.receiverFullName": "Полное имя получателя",
        "vehicles.receiverIdentityNumber": "Идентификационный номер получателя",
        "vehicles.receiverPhone": "Телефон получателя",

        // receiver 2-day rule
        "vehicles.receiverRequired": "Нужен получатель",
        "vehicles.receiverTimeLeft": "Время на указание получателя",
        "vehicles.receiverExpired": "Срок истёк",
        "vehicles.receiverReminderText": "Пожалуйста, укажите получателя до истечения срока — после этого изменить его сможет только администратор.",
        "vehicles.receiverLockedTitle": "Получатель заблокирован",
        "vehicles.receiverLockedText": "Срок изменения получателя истёк. Пожалуйста, свяжитесь с администратором.",
        "vehicles.receiverSet": "Получатель указан",
        "vehicles.unitDay": "д",
        "vehicles.unitHour": "ч",
        "vehicles.unitMinute": "м",

        // title tracking
        "vehicles.titleReceivedDate": "Дата получения тайтла",
        "vehicles.titleMissing": "Нет тайтла",
        "vehicles.titleWarning": "Загружен без тайтла!",
        "vehicles.titleReceived": "Тайтл получен",
    },
    geo: {
        "vehicles.title": "ავტომობილები",

        "vehicles.image": "სურათი",
        "vehicles.dealer": "დილერი",
        "vehicles.purchaseDate": "შეძენის თარიღი",
        "vehicles.vehicleName": "ავტომობილის სახელი",
        "vehicles.receiver": "მიმღები",
        "vehicles.personalNumber": "პირადი ნომერი",
        "vehicles.phone": "ტელეფონი",
        "vehicles.container": "კონტეინერი",
        "vehicles.booking": "ჯავშანი",
        "vehicles.line": "ხაზი",
        "vehicles.auction": "აუქციონი",
        "vehicles.state": "შტატი",
        "vehicles.paid": "გადახდილი",
        "vehicles.transportation": "ტრანსპორტირება",
        "vehicles.carAmount": "ავტომობილის ღირებულება",
        "vehicles.debt": "დავალიანება",
        "vehicles.status": "სტატუსი",
        "vehicles.green": "მწვანე",

        "vehicles.addReceiver": "მიმღების დამატება",
        "vehicles.markAsGreen": "მონიშნე მწვანედ",
        "vehicles.uploadImages": "სურათების ატვირთვა",
        "vehicles.containerLoaded": "კონტეინერი დატვირთულია",
        "vehicles.addNote": "შენიშვნის დამატება",
        "vehicles.carInvoice": "ავტომობილის ინვოისი",
        "vehicles.transportationInvoice": "ტრანსპორტირების ინვოისი",

        "vehicles.sortContainerLoaded": "კონტეინერის დატვირთვის თარიღი",
        "vehicles.sortContainerReceive": "კონტეინერის მიღების თარიღი",
        "vehicles.sortEstOpening": "გახსნის სავარაუდო თარიღი",
        "vehicles.sortOpenDate": "გახსნის თარიღი",
        "vehicles.sortDesc": "კლებადობით",
        "vehicles.oldToNew": "ძველიდან ახლისკენ",
        "vehicles.newToOld": "ახლიდან ძველისკენ",
        "vehicles.port": "პორტი",
        "vehicles.portNumber1": "პორტი ნომერი 1",
        "vehicles.portNumber2": "პორტი ნომერი 2",
        "vehicles.portNumber3": "პორტი ნომერი 3",
        "vehicles.selectLine": "აირჩიეთ ხაზი",

        "vehicles.confirmPrompt": "გსურთ",
        "vehicles.confirmRemoveCar": "ამ ავტომობილის წაშლა",
        "vehicles.confirmMarkGreen": "ამ ავტომობილის მწვანედ მონიშვნა",
        "vehicles.confirmContainerLoaded": "კონტეინერის დატვირთულად მონიშვნა",
        "vehicles.estimatedReceiveDate": "მიღების სავარაუდო თარიღი",

        "vehicles.modifyCarData": "ავტომობილის მონაცემების რედაქტირება",
        "vehicles.addNewCar": "ახალი ავტომობილის დამატება",
        "vehicles.user": "მომხმარებელი",
        "vehicles.enterUser": "შეიყვანეთ მომხმარებელი",
        "vehicles.userNotFound": "მომხმარებელი ვერ მოიძებნა",
        "vehicles.enterVin": "შეიყვანეთ VIN კოდი",
        "vehicles.mark": "მარკა",
        "vehicles.enterMark": "შეიყვანეთ მარკა",
        "vehicles.model": "მოდელი",
        "vehicles.enterModel": "შეიყვანეთ მოდელი",
        "vehicles.year": "წელი",
        "vehicles.enterYear": "შეიყვანეთ წელი",
        "vehicles.lotNumber": "ლოტის ნომერი",
        "vehicles.enterLotNumber": "შეიყვანეთ ლოტის ნომერი",
        "vehicles.selectAuction": "აირჩიეთ აუქციონი",
        "vehicles.usState": "აშშ შტატი",
        "vehicles.enterUsState": "შეიყვანეთ აშშ შტატი",
        "vehicles.cityNotFound": "ქალაქი ვერ მოიძებნა",
        "vehicles.usPort": "აშშ პორტი",
        "vehicles.selectDestinationPort": "აირჩიეთ დანიშნულების პორტი",
        "vehicles.destinationPort": "დანიშნულების პორტი",
        "vehicles.documentType": "დოკუმენტის ტიპი",
        "vehicles.enterDocType": "შეიყვანეთ დოკ. ტიპი",
        "vehicles.containerCost": "კონტეინერის ღირებულება",
        "vehicles.enterContainerCost": "შეიყვანეთ კონტეინერის ღირებულება",
        "vehicles.landingCost": "გადმოტვირთვის ღირებულება",
        "vehicles.enterLandingCost": "შეიყვანეთ გადმოტვირთვის ღირებულება",
        "vehicles.vehiclePrice": "ავტომობილის ფასი",
        "vehicles.enterVehiclePrice": "შეიყვანეთ ავტომობილის ფასი",
        "vehicles.totalPrice": "ჯამური ფასი",
        "vehicles.enterTotalPrice": "შეიყვანეთ ჯამური ფასი",
        "vehicles.vehicleAdditionalAmount": "ავტომობილის დამატებითი თანხა",
        "vehicles.transportationAdditionalAmount": "ტრანსპორტირების დამატებითი თანხა",
        "vehicles.buyerNumber": "მყიდველის ნომერი",
        "vehicles.enterBuyerNumber": "შეიყვანეთ მყიდველის ნომერი",
        "vehicles.vehicleType": "ავტომობილის ტიპი",
        "vehicles.selectVehicleType": "აირჩიეთ ავტომობილის ტიპი",
        "vehicles.typeSedan": "სედანი/ჰეჩბექი",
        "vehicles.typeJeep": "ჯიპი/კროსოვერი",
        "vehicles.typeJeepOversize": "ჯიპი დიდი ზომის",
        "vehicles.typeMinivan": "მინივენი",
        "vehicles.typeMicrobus": "მიკროავტობუსი",
        "vehicles.typeJetski": "ჯეტ სკი-სნოუმობილი",
        "vehicles.typeMotorcycle": "მოტოციკლი",
        "vehicles.insuranceType": "დაზღვევის ტიპი",
        "vehicles.hasKey": "აქვს გასაღები",
        "vehicles.isHybrid": "ჰიბრიდი",
        "vehicles.isSublot": "საბლოტი",
        "vehicles.isFunded": "დაფინანსებული",
        "vehicles.isInsured": "დაზღვეული",
        "vehicles.isClosedCode": "დახურული კოდი (+$100)",
        "vehicles.pending": "მოლოდინში",
        "vehicles.attachImage": "სურათის მიმაგრება",
        "vehicles.saveAndAttach": "შენახვა და სურათების მიმაგრება",
        "vehicles.upload": "ატვირთვა",

        "vehicles.selectImageType": "აირჩიეთ სურათის ტიპი",
        "vehicles.poti": "ფოთი",
        "vehicles.selectImageTypeWarning": "გთხოვთ აირჩიოთ სურათების ტიპი",

        "vehicles.receiverFullName": "მიმღების სრული სახელი",
        "vehicles.receiverIdentityNumber": "მიმღების პირადი ნომერი",
        "vehicles.receiverPhone": "მიმღების ტელეფონი",

        // receiver 2-day rule
        "vehicles.receiverRequired": "მიმღები საჭიროა",
        "vehicles.receiverTimeLeft": "დარჩენილი დრო მიმღების მისათითებლად",
        "vehicles.receiverExpired": "ვადა ამოიწურა",
        "vehicles.receiverReminderText": "გთხოვთ მიუთითოთ მიმღები ვადის ამოწურვამდე — ამის შემდეგ მის შეცვლას მხოლოდ ადმინისტრატორი შეძლებს.",
        "vehicles.receiverLockedTitle": "მიმღები დაბლოკილია",
        "vehicles.receiverLockedText": "მიმღების შეცვლის ვადა ამოიწურა. გთხოვთ, დაუკავშირდეთ ადმინისტრატორს.",
        "vehicles.receiverSet": "მიმღები მითითებულია",
        "vehicles.unitDay": "დღ",
        "vehicles.unitHour": "სთ",
        "vehicles.unitMinute": "წთ",

        // title tracking
        "vehicles.titleReceivedDate": "საბუთის (Title) მისვლის თარიღი",
        "vehicles.titleMissing": "საბუთი არ მისულა",
        "vehicles.titleWarning": "ჩატვირთულია საბუთის გარეშე!",
        "vehicles.titleReceived": "საბუთი მისულია",
    },
};

export default vehicles;
